import React from 'react';
import { Col, Form, Image, InputNumber, Row } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { I18n } from '@aws-amplify/core';

import { useLibertyMutualSubStepsContext } from '../../context';
import { CustomLabel, CustomTooltip } from './CustomLabel';
import { TaskName } from '../../hooks/types/response';
import { SystemOfUnits } from '../../context/types';

const PUSH_VERTICAL_HAND_HEIGHT =
	'https://kinebot-statics.s3.amazonaws.com/liberty-mutual/push-vertical-hand-height.svg';
const PULL_VERTICAL_HAND_HEIGHT =
	'https://kinebot-statics.s3.amazonaws.com/liberty-mutual/pull-vertical-hand-height.svg';
const CARRY_VERTICAL_HAND_HEIGHT =
	'https://kinebot-statics.s3.amazonaws.com/liberty-mutual/carry-vertical-hand-height.svg';

export const VerticalHandHeight = () => {
	const { libertyMutual, decimalSeparator } = useLibertyMutualSubStepsContext();

	const systemOfUnitsToSymbolMapper: SystemOfUnits = {
		metric: 'cm',
		imperial: 'in'
	};

	const labelTitle = `${I18n.get('Vertical hand height')} (${
		systemOfUnitsToSymbolMapper[libertyMutual?.system_of_units?.name]
	})`;

	const tooltipSVGMapper = {
		[TaskName.lift]: '',
		[TaskName.lower]: '',
		[TaskName.push]: PUSH_VERTICAL_HAND_HEIGHT,
		[TaskName.pull]: PULL_VERTICAL_HAND_HEIGHT,
		[TaskName.carry]: CARRY_VERTICAL_HAND_HEIGHT
	};

	const TooltipContent = (
		<Row align="bottom">
			<Col xs={7}>
				<Image src={tooltipSVGMapper[libertyMutual.task.name]} alt={labelTitle} preview={false} width="60px" />
			</Col>
		</Row>
	);

	const label = (
		<CustomLabel
			icon={
				<CustomTooltip top={-120} left={14} content={TooltipContent} placement="topLeft">
					<InfoCircleOutlined style={{ fontSize: '0.65rem', marginLeft: '0.1rem' }} />
				</CustomTooltip>
			}
			title={labelTitle}
		/>
	);

	return (
		<Row>
			<Col xs={24}>
				<Form.Item
					name={['liberty_mutual_inputs', 'vertical_hand_height']}
					label={label}
					labelCol={{ span: 24 }}
					rules={[
						() => ({
							validator(_, value) {
								if (value < 1) {
									return Promise.reject(I18n.get('Insert a vertical hand height'));
								}
								return Promise.resolve();
							}
						}),
						{
							required: true,
							message: ''
						}
					]}
				>
					<InputNumber min={1} placeholder="0" decimalSeparator={decimalSeparator} />
				</Form.Item>
			</Col>
		</Row>
	);
};
